import { apiClient } from "../../Service";
import { objectToUserProfile, collectionToUserProfileActivities, collectionToUserProfileMissions, } from "./Transformer";
async function getProfileInfo(userId) {
    const client = apiClient();
    const params = {
        user_id: userId,
    };
    return client
        .get("/appv2/profile/info", { params })
        .then((response) => objectToUserProfile(response.data));
}
async function getProfileActivities(userId) {
    const client = apiClient();
    const params = {
        user_id: userId,
    };
    return client
        .get("/appv2/profile/stats", { params })
        .then((response) => collectionToUserProfileActivities(response.data));
}
async function getProfileMissions(userId) {
    const client = apiClient();
    const params = {
        user_id: userId,
    };
    return client
        .get("/appv2/profile/missions", { params })
        .then((response) => collectionToUserProfileMissions(response.data));
}
export const ProfileService = {
    getProfileInfo,
    getProfileActivities,
    getProfileMissions,
};
